/**
 * Service de calcul des prix pour le configurateur
 * Logique métier pure, indépendante des stores Vue/Pinia
 */

import type { GradeItem, ConfigItem } from '../types';

export interface PricingInputs {
  grade: GradeItem | null;
  availableItems: ConfigItem[];
  selectedItems: Record<string, boolean>;
  /** Prix de la teinte extérieure */
  exteriorTeintePrice?: number;
  /** Prix de la teinte intérieure */
  interiorTeintePrice?: number;
}

export const PricingService = {
  /**
   * Calcule le prix total simplifié = basePrice grade + somme price des options sélectionnées + prix des teintures
   * @param inputs - Données nécessaires au calcul
   * @returns Prix total (number)
   */
  calculateTotalPrice({ grade, availableItems, selectedItems, exteriorTeintePrice = 0, interiorTeintePrice = 0 }: PricingInputs): number {
    let total = (grade?.basePrice ?? 0);

    // Somme des prix des items sélectionnés
    Object.entries(selectedItems).forEach(([itemId, isSelected]) => {
      if (isSelected) {
        const item = availableItems.find((i: ConfigItem) => i.item_id === itemId);
        if (item?.price !== undefined) {
          const itemPrice = parseFloat(item.price) || 0;
          total += itemPrice;
        }
      }
    });

    // Ajouter les prix des teintures
    total += exteriorTeintePrice;
    total += interiorTeintePrice;

    return total;
  }
};